document.addEventListener('DOMContentLoaded', () => {
    initAnchorLinks();
    initResizeShapes('#sticker-sticker-feature-logo-with-image-0');
    initResizeShapes('#sticker-sticker-feature-logo-with-image-1');
});

const initAnchorLinks = () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

    anchorLinks.forEach(link => {
        link.addEventListener('click', e => {
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                e.preventDefault();

                if (window.Alpine && Alpine.store('modals')?.leftDrawer?.open) {
                    Alpine.store('modals').close('leftDrawer');
                }

                setTimeout(() => {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    // history.pushState(null, null, `#${targetId}`);
                }, 300);
            }
        });
    });
}

const initResizeShapes = (elem_ID) => {
    function updateBlockWidth(elem_ID) {
        const el = document.querySelector(elem_ID);
        if (!el) return;

        const vw = window.innerWidth;
        let widthValue;

        if (vw < 600) {
            widthValue = vw / 4.5;
        } else if (vw < 1024) {
            widthValue = vw / 5.5;
        } else {
            widthValue = vw / 6.5;
        }

        el.style.setProperty('--block-width', widthValue.toFixed(2));
    }

    updateBlockWidth(elem_ID);
    window.addEventListener('resize', () => { updateBlockWidth(elem_ID) });
}